const Header = () => {
    return (
        <>

            <nav className="navbar navbar-expand-lg bg-white navbar-light shadow border-top border-5 border-primary sticky-top p-0">
                <a href="/" className="navbar-brand  d-flex align-items-center px-4 px-lg-5">
                    <img src="img/a2zlogo.png" alt="A2Z Solutions" className="img" style={{ maxWidth: " auto ", height: "70px" }} />
                </a>
                <button type="button" className="navbar-toggler me-4" data-bs-toggle="collapse" data-bs-target="#navbarCollapse">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarCollapse">
                    <div className="navbar-nav ms-auto p-4 p-lg-0">
                        <a href="/" className="nav-item nav-link active">Home</a>
                        <a href="/about" className="nav-item nav-link">Why Us</a>
                        <a href="/service" className="nav-item nav-link">What We Do</a>
                        <div className="nav-item dropdown">
                            <a href="#" className="nav-link dropdown-toggle" data-bs-toggle="dropdown">Services</a>
                            <div className="dropdown-menu fade-up m-0">
                                <a href="/academic" className="dropdown-item">Academic Education</a>
                                <a href="/med" className="dropdown-item">Medical Billing</a>
                                <a href="/data" className="dropdown-item">Annotation & Data Entry Services</a>
                                <a href="/web" className="dropdown-item">Web Development</a>
                                <a href="/training" className="dropdown-item">Training Services</a>
                                <a href="/man" className="dropdown-item">Man Power Services</a>
                                <a href="/hardware" className="dropdown-item">Computer Hardware Equipments Services</a> 


                            </div>
                        </div>
                        <a href="/contact" className="nav-item nav-link">Contact</a>
                    </div>
                    <h4 className="m-0 pe-lg-5 d-none d-lg-block " style={{ fontSize: "18px" }}><i className="fa fa-headphones text-primary me-3"></i>+91 9886295510</h4>
                </div>
            </nav>


        </>
    );
}
export default Header;